import React from "react";

const LeetcodeLogo = () => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="28px"
      height="28px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        //fill="#000000"
        stroke="none"
      >
        <path
          d="M2985 5104 c-47 -14 -125 -90 -1196 -1162 -775 -776 -1158 -1166
-1185 -1207 -224 -347 -256 -810 -83 -1194 73 -161 114 -208 673 -768 423
-423 547 -542 609 -582 188 -121 363 -175 608 -188 283 -15 567 68 775 225 47
35 213 197 395 384 300 307 316 326 333 382 43 135 -26 286 -159 351 -71 35
-171 36 -240 4 -34 -16 -142 -113 -376 -340 -297 -287 -336 -322 -402 -353
-97 -47 -174 -60 -305 -53 -113 6 -191 26 -266 71 -23 14 -271 255 -552 538
-460 463 -513 519 -542 579 -90 186 -81 423 22 583 42 66 981 1020 1049 1066
163 111 451 117 629 13 26 -16 190 -165 364 -333 185 -179 337 -317 367 -335
45 -26 62 -30 127 -30 59 0 85 5 124 24 104 51 168 150 170 261 2 125 0 128
-358 489 -176 178 -355 349 -397 380 -90 68 -215 131 -321 162 l-78 23 280
281 c311 314 323 330 324 445 2 200 -196 345 -389 284z"
        />
        <path
          d="M2165 2316 c-204 -95 -213 -401 -14 -511 l54 -30 1155 0 c1086 0
1157 1 1187 18 135 73 196 230 144 369 -26 66 -85 132 -144 159 -40 18 -85 19
-1187 19 l-1145 0 -50 -24z"
        />
      </g>
    </svg>
  );
};

export default LeetcodeLogo;
